/**
 * @desc 邀请撤回
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type WithdrawAuctionApplyParameter = {
  applyId?: string
}

const method = 'POST'
const url = '/trade/operation/apply/auction/withdraw'

export const withdrawAuctionApplyApi = (
  params?: WithdrawAuctionApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

withdrawAuctionApplyApi.method = method
withdrawAuctionApplyApi.url = url
